import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import { Button } from "react-bootstrap";
import { OAuthApiStartPolling, OAuthApiStopPolling } from "../../ExternalApi/OAuthApi"
import { ConfigurationApiForward } from "../../ExternalApi/ConfigurationApi"
import IntegrationWizardDots from "../IntegrationWizard/IntegrationWizardDots"
import { GetDatasourceName } from "../Datasources/Datasources.jsx"
import { random } from "lodash";
import { IsEmptyString } from "../GeneralFunctions.jsx";
import { CrmServerLocation } from "../GeneralFunctions.jsx";
import axios from "axios";

const DatasourceBaseOauthNew = (props) => {
    
    const [mRepainter, SetRepainter] = useState(false); 
    const [mWaitingForState, SetWaitingForState] = useState("")
    const [mError, SetError] = useState("") 
    const [mOAuthWindow, SetOAuthWindow] = useState(null) 

    useEffect(() => {
        SetReady()
      }, []); 
    
    const SetReady = () => 
    {
        props.OnSetReady(props.IntegrationSettings.DatasourceSettings.RefreshToken || ((props.NoRefreshToken === true) && props.IntegrationSettings.DatasourceSettings.AccessToken))
    }

    const GetTokens = async (aAuthorizationCode) =>
    {
        try 
        {
            console.log("GetTokens",aAuthorizationCode,props.IntegrationSettings.DatasourceSettings)
            const result = await axios.post(
                CrmServerLocation() + props.CrmServerTokenController, 
                {
                    ...props.IntegrationSettings.DatasourceSettings,
                    AuthorizationCode: aAuthorizationCode
                },
                {
                    headers:
                    {
                        Authorization: "Bearer " + props.SecurityToken,
                        ContentType: "application/json"
                    }
                }
            )
            console.log("GetTokens success", result)

            props.IntegrationSettings.DatasourceSettings.AccessToken = result.data.AccessToken
            props.IntegrationSettings.DatasourceSettings.RefreshToken = result.data.RefreshToken

            console.log("OtherOauthResultFields", props.OtherOauthResultFields, result.data)
            if (props.OtherOauthResultFields)
            {
                Object.entries(props.OtherOauthResultFields || {}).map(([name,value]) => props.IntegrationSettings.DatasourceSettings[name] = result.data[value])
            }

            if (props.OnOAuthGetTokenDone)
            {
                props.OnOAuthGetTokenDone()
            }
        } 
        catch (error) 
        {
            console.log("GetTokens failed", error)
        }
    }

    const OAuthPollResult = async (aResult, aValue, aOAuthWindow) =>
    {
        try 
        { 
            if (aOAuthWindow !== null)
            {
                aOAuthWindow.close() 
                aOAuthWindow = null
                SetOAuthWindow(null)
            }
        } 
        catch {}

        if (aResult)
        {
            console.log("OAuthPollResult success: " + JSON.stringify(aValue))
            if (aValue.Code && aValue.ResponseUrl)
            {
                if (props.OnOAuthPollResult)
                {
                    await props.OnOAuthPollResult(aValue.ResponseUrl)
                }
                await GetTokens(decodeURIComponent(aValue.Code))
                SetReady()
            }
            else
            {
                SetError("Failed to authenticate. No authorizationcode found")  
            }
        }
        else
        {
            console.log("OAuthPollResult error: " + JSON.stringify(aValue))  
            SetError("Failed to authenticate")          
        }
    }

    const RandomState = () => 
    {
        let Result = "client2020WEB"

        var characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for ( var i = 0; i < 27; i++ ) 
        {
            Result += characters.charAt(Math.floor(Math.random() * characters.length))
        }
        
        return Result
    }

    const StartOAuth = () =>
    {
        const State = RandomState()

        const OAuthUrl = props.AuthUrl + "&state=" + State
        const OAuthWindow = window.open(OAuthUrl, "_blank", 'popup=yes,titlebar=0,left=' + ((screen.availWidth - 750)/2)  + ',top=' + ((screen.availHeight - 750)/2)  + ',width=750,height=750')
        SetOAuthWindow(OAuthWindow)
        OAuthApiStartPolling(State, OAuthPollResult, OAuthWindow)

        SetWaitingForState(State)
    }

    const StopOAuth = () =>
    {
        try 
        { 
            if (mOAuthWindow !== null)
            {
                mOAuthWindow.close() 
                SetOAuthWindow(null)
            }
        } 
        catch {}

        OAuthApiStopPolling()

        SetWaitingForState("")
    }

    const BrandingId = sessionStorage.getItem("BrandingId")

    const Body = props.IntegrationSettings.DatasourceSettings.RefreshToken || ((props.NoRefreshToken === true) && props.IntegrationSettings.DatasourceSettings.AccessToken) ?
        //Authorization OK
        <div className="scriptitembody">
            {Translate("$Application connection token received succesfully").replace("$Application",!IsEmptyString(props.OverrideName) ? props.OverrideName : GetDatasourceName(props.IntegrationSettings.DatasourceType))}
        </div> :
        (mError ?
            //Authorization failed. Show error and connect button
            <div className="scriptitembody">
                <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button><br/>
                <div>{mError}</div>
            </div> :
            (mWaitingForState ?
                //Waiting for authorization. Show dot counter and cancel button
                <div className="scriptitembody">
                    <Button variant="danger" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StopOAuth()} type="submit">{Translate("Cancel")}</Button><br/><br/>
                    <div>{Translate("Waiting for OAUTH verification")}<IntegrationWizardDots/></div>
                </div> :
                //Not authenticating. Show connect button
                <div className="scriptitembody">
                    <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button>
                </div>
            )
        )

    return (
        <span>{Body}</span>
    )
}

DatasourceBaseOauthNew.propTypes = {   
    SecurityToken: PropTypes.string, 
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    AuthUrl: PropTypes.string, //the url of the oauth request in your browser
    CrmServerTokenController: PropTypes.string,
    OtherOauthResultFields: PropTypes.object, //extra gettoken request return fields (datasourcesettingfield => gettokenreturnfield)
    OnOAuthPollResult: PropTypes.func, //prerequest before getting token, argument: responseurl
    OnOAuthGetTokenDone: PropTypes.func, //postrequest after getting token, argument: none
    OnSetReady: PropTypes.func
}   

export default DatasourceBaseOauthNew